import React, { useState } from 'react'
import { Panel, Row, Message } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useForm, Controller } from 'react-hook-form'
import moment from 'moment'
import { startLoading, doneLoading } from '../../utils/loading'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import WorkingGroupForm from '../../components/forms/workingGroupForm/WorkingGroupForm'
import WorkingGroupView from '../projectProposal/workingGroup/WorkingGroupView'
import { saveAttorneyPerson } from '../../redux/actions/attorney'

export default function AttorneyPerson({
  schema: _schema,
  header,
  showCommandButton,
  isEdit,
  setIsEdit,
  updatePerson,
  projectVersionId,
}) {
  const formPerson = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const handleSaveAttorneyPerson = async (request) => {
    startLoading()
    setIsLoading(true)
    setError()
    try {
      const response = await saveAttorneyPerson(projectVersionId || projectId, request)
      setFormSchema(response.model.attorneyPerson[0])
      updatePerson(response.model.attorneyPerson[0])
      setIsEdit(false)
    } catch (e) {
      setError('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    const formData = new FormData()
    formData.append('Id', formSchema.id || '')
    data.idCard?.forEach((element) => {
      formData.append('IdCard', element.blobFile)
    })
    data.attorneyFile?.forEach((element) => {
      formData.append('attorneyFile', element.blobFile)
    })
    formData.append('IdNumber', data.idNumber || '')
    formData.append('Honorific', data.honorific || '')
    formData.append('FirstName', data.firstName || '')
    formData.append('LastName', data.lastName || '')
    formData.append('Nationality', parseInt(data.nationality) || 1)
    formData.append('NationalityOther', data.nationalityInputOther || '')
    formData.append('DateOfBirth', moment(data.dateOfBirth).format('YYYY/MM/DD') || '')
    formData.append('Telephone', data.telephone || '')
    formData.append('Mobile', data.mobile || '')
    formData.append('Fax', data.fax || '')
    formData.append('Email', data.email || '')
    formData.append('LineId', data.lineId || '')
    formData.append('BuildingName', data.buildingName || '')
    formData.append('RoomNumber', data.roomNumber || '')
    formData.append('HouseNumber', data.houseNumber || '')
    formData.append('VillageNumber', data.villageNumber || '')
    formData.append('Lane', data.lane || '')
    formData.append('VillageName', data.villageName || '')
    formData.append('Road', data.road || '')
    formData.append('Location', data.location || '')

    handleSaveAttorneyPerson(formData)
  }

  return (
    <>
      <Panel
        header={header}
        collapsible
        defaultExpanded
        bordered
        shaded
        style={{ marginBottom: 20 }}
      >
        {isEdit && showCommandButton ? (
          <WorkingGroupForm
            schema={formSchema}
            Controller={Controller}
            {...formPerson}
          ></WorkingGroupForm>
        ) : (
          <div>
            <WorkingGroupView data={formSchema} />
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            {isEdit ? (
              <>
                {error && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message
                      showIcon
                      type="error"
                      description={
                        'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                      }
                    />
                  </Row>
                )}
                <SaveButton onClick={formPerson.handleSubmit(onSubmit)} disabled={isLoading} />
                <CancelButton onClick={() => setIsEdit(false)} />
              </>
            ) : (
              <EditButton onClick={() => setIsEdit(true)}>แก้ไขการมอบอำนาจ</EditButton>
            )}
          </>
        )}
      </Panel>
    </>
  )
}
